<template>
  <router-link :to="to" v-if="to" class="button" :class="classList"
    ><slot
  /></router-link>
  <a :href="href" v-else-if="href" :class="classList" class="button">
    <slot />
  </a>
  <button :disabled="disabled" v-else class="button" :class="classList">
    <slot />
  </button>
</template>

<script>
export default {
  name: 'AppButton',
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    variant: {
      type: String,
      required: false,
    },
    color: {
      type: String,
      required: false,
    },
    align: {
      type: String,
      required: false,
    },
    size: {
      type: String,
      required: false,
    },
    to: {
      type: Object,
      required: false,
      default: undefined,
    },
    href: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    classList() {
      const list = [];
      if (this.variant) {
        switch (this.variant) {
          case 'cta':
            list.push('button--cta');
            break;
          case 'text':
            list.push('button--text');
            break;
          case 'outline':
            list.push('button--outline');
            break;
        }
      }

      if (this.color) {
        list.push(`button--${this.color}`);
      }

      if (this.size) {
        switch (this.size) {
          case 'sm':
            list.push('button--small');
            break;
          case 'lg':
            list.push('button--small');
            break;
        }
      }

      if (this.align) {
        switch (this.align) {
          case 'start':
            list.push('button--start');
            break;
          case 'end':
            list.push('button--end');
            break;
          case 'center':
            list.push('button--center');
            break;
          case 'stretch':
            list.push('button--stretch');
            break;
        }
      }

      return list.join(' ');
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  color: color('primary', 'text');
  background-color: color('primary');
  height: 48px;
  display: flex;
  align-self: flex-start;
  align-items: center;
  justify-content: center;
  font-family: 'futura-pt';
  line-height: 1rem;
  font-size: calc-font-size(18);
  position: relative;
  font-weight: 300;
  transition: background 128ms ease-in-out;

  &--small {
    height: 32px;
    font-size: calc-font-size(16);
  }

  &--outline {
    background: transparent;
    border: 1px solid color('grey');
    color: color('text');

    &:hover {
      color: color('primary');
    }
  }

  &--text {
    background: transparent !important;
    color: color('text');
    font-weight: inherit;

    &.button--primary {
      color: color('primary');
    }

    &.button--secondary {
      color: color('secondary');
    }

    &.button--success {
      color: color('denotive', 'success');
    }

    &.button--warning {
      color: color('denotive', 'warning');
    }

    &.button--error {
      color: color('denotive', 'error');
    }

    &.button--light {
      color: color('text', 'light');
    }
  }

  &.button--primary {
    background-color: color('primary');
  }

  &.button--secondary {
    background-color: color('secondary');
  }

  &.button--success {
    background-color: color('denotive', 'success');
  }

  &.button--warning {
    background-color: color('denotive', 'warning');
  }

  &.button--error {
    background-color: color('denotive', 'error');
  }

  &.button--light {
    background-color: color('text', 'light');
  }

  &.button--cta {
    color: white;
    background-color: #ff7dae;
    background-image: linear-gradient(to left, #ff7dae, #cc00cc);
    background-position: center center;
    background-size: 100%;
    font-weight: 100;
    box-shadow: 0 0 4px 1px rgba(#752b6e, 0.22);
    transition: all 128ms ease-in-out;

    &:focus,
    &:hover {
      background-image: linear-gradient(to left, #ff7dae, #cc00cc);
      background-position: center center;
      background-size: 200%;
    }

    &:focus {
      border: 2px solid white;
    }

    &:active {
      background-image: none;
    }
  }

  &.button--start {
    align-self: flex-start;
  }

  &.button--center {
    align-self: center;
  }

  &.button--end {
    align-self: flex-end;
  }

  &.button--stretch {
    align-self: auto;
  }

  &:disabled {
    background-image: linear-gradient(to left, #ff7dae, #cc00cc);
    background-position: center center;
    background-size: 300%;
    filter: grayscale(100%);
    opacity: 0.8;
    box-shadow: none;
  }
}
</style>
